import {
    type GetAllSentMailsResponseType,
    type GetAllSentMailsRequestType
} from "./type";
import {
    request
} from "../request";

const getAllSentMails = async (
    params: GetAllSentMailsRequestType
): Promise<GetAllSentMailsResponseType> => {
    const serializedParams = {
        ...params
    } as Record<string, string | number | boolean | undefined>;

    const filteredParams = Object.fromEntries(
        Object.entries(serializedParams).filter(entry => entry[1] !== undefined && entry[1] !== null && entry[1] !== "")
    );
    const queryStr = Object.keys(filteredParams).length > 0 ? `?${new URLSearchParams(filteredParams as Record<string, string>).toString()}` : "";

    return await request<GetAllSentMailsResponseType>(
        `/notification/getAllSentMails${queryStr}`,
        {
            method: "GET"
        }
    );
};
export default getAllSentMails;
